import React from 'react'
import Snackbar, { SnackbarProps } from './Snackbar'

interface SnackbarContext {
  openSnackbar: (props: SnackbarProps) => void
  closeSnackbar: () => void
}

const SnackbarContext = React.createContext<SnackbarContext>({
  openSnackbar(): void { return },
  closeSnackbar(): void { return },
})

interface SnackbarProviderProps {
  children: React.ReactNode
}


export function SnackbarProvider({ children }: SnackbarProviderProps): JSX.Element {
  const [snackbarProps, setSnackbarProps] = React.useState<SnackbarProps | null>(null)

  const openSnackbar = React.useCallback((newProps: SnackbarProps): void => {
    setSnackbarProps(newProps)
  }, [])

  const closeSnackbar = React.useCallback((): void => {
    setSnackbarProps(null)
  }, [])

  const value = React.useMemo(() => ({ openSnackbar, closeSnackbar }), [openSnackbar, closeSnackbar])

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      {snackbarProps && <Snackbar {...snackbarProps} onClose={closeSnackbar} />}
    </SnackbarContext.Provider>
  )
}

export const useSnackbar = (): SnackbarContext  => {
  return React.useContext<SnackbarContext>(SnackbarContext)
}
